import * as React from 'react';
import styled from 'styled-components';

const MaterialIcon = styled.i`
  font-family: 'Material Icons';
`;

export function Icon({ name, variant = 'filled' }) {
  const variants = {
    filled: 'material-icons',
    rounded: 'material-icons-round',
    outline: 'material-icons-outlined',
    sharp: 'material-icons-sharp',
  };

  return <MaterialIcon className={variants[variant]}>{name}</MaterialIcon>;
}
